import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Spinner extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      visible: (this.props.fadeIn === 0)
    };
  }

  componentDidMount() {
    this.timeout = setTimeout(() => this.setState({ visible: true }), this.props.fadeIn);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    const className = `igglo_spinner ${this.props.className}`;

    if (!this.state.visible) {
      return (<div className={className} />);
    }

    return (
      <div className={className}>
        <svg viewBox="0 0 100 100">
          <linearGradient id="a" gradientUnits="userSpaceOnUse" x1="6.0528" x2="93.9578" y1="81.25" y2="81.25">
            <stop offset="0" stopColor={this.props.color} />
            <stop offset="1" stopColor={this.props.endColor} stopOpacity="0" />
          </linearGradient>
          <path id="b" d="m8.6 67.5c3.7 8.9 10.3 16.5 18.9 21.5 13.9 8 31.1 8 45 0 8.6-5 15.2-12.6 19-21.5" fill="none" stroke="url(#a)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5" />
          <use height="100%" transform="matrix(-1 0 0 -1 100.1 99.9)" width="100%" xlinkHref="#b" />
        </svg>
      </div>
    );
  }
}

Spinner.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  endColor: PropTypes.string,
  fadeIn: PropTypes.number
};

Spinner.defaultProps = {
  className: '',
  color: '#fc3a64',
  endColor: '#fff',
  fadeIn: 1000
};

export default Spinner;
